import React, {useState} from 'react';
import {ReturnTextAndImg} from "../CheckImg";

const WithExplanation = ({changeWriteAnswer, data, isPassed}) => {
    const [answer, setAnswer] = useState([])
    const [textAnswer,setTextAnswer] =useState('')
    const styles = {
        backgroundColor: 'rgba(255, 253, 152, 0.76)',
    }

    const style = isPassed ? styles : null

    function changeAnswer(value, type, e) {
        if(!isPassed) {
            let arrAnswer = answer;
            let txt = textAnswer;
            if (type === 1) {
                setAnswer([value])
                arrAnswer[0] = value;
            } else if (type === 2) {
                if (e.target.checked) {
                    setAnswer(item => [...item, value])
                    arrAnswer = [...answer, value]
                } else {
                    setAnswer(answer.filter(item => item !== value))
                    arrAnswer = answer.filter(item => item !== value);
                }
            } else if (type === 3) {
                setTextAnswer(value)
                txt = value;
            }
            changeWriteAnswer({answer: arrAnswer, text: txt})
        }
    }

    const fields = data?.map((item, i) => {
       let text = ReturnTextAndImg(item.text);

        if (item.type === 1) {
            return <div style={{    display: 'flex',
                alignItems: 'center'}}
                        key={i} onClick={e => {changeAnswer(item.text, item.type)}}><input type="radio" checked={answer[0] === item.text} readOnly disabled={isPassed}/>{text}</div>
        } else if (item.type === 2) {
            return <div style={{    display: 'flex',
                alignItems: 'center'}} key={i} onClick={e => {changeAnswer(item.text, item.type, e)}}><input type="checkbox"  disabled={isPassed}/>{text}</div>
        }
    })
    return (
        <div>
            <div style={style}>
                {
                    fields
                }
            </div>
            <div>
                <label className="test-check-text">Введите пояснение:</label>
                <textarea style={style}  value={textAnswer} placeholder="Введите свой ответ" onChange={(e) => changeAnswer(e.target.value,3,e)}
                          disabled={isPassed}/>
                {isPassed ? <label className="test-check-text">Ваш ответ проверяется специалистом</label> : null}
            </div>
        </div>
    );
};

export default WithExplanation;